import { Head, Link } from "@inertiajs/react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { Button } from "@/components/ui/button"
import { ProjectForm, type CustomerOption } from "@/components/projects/ProjectForm"

type ProjectDetail = {
  id: number
  lot_number: string | null
  plan_name: string | null
  elevation: string | null
  address: string | null
  notes: string | null
  status: string
  display_name: string
  customer_id: number | null
  community_id: number | null
  building_type: string | null
  work_type: string | null
  gate_code: string | null
  project_manager: string | null
  customer_phone: string | null
  unit_apartment: string | null
  city: string | null
  state: string | null
  postal_code: string | null
  subfloor: string
  schedule_comments: string | null
}

export default function ProjectsEdit({
  project,
  customers,
}: {
  project: ProjectDetail
  customers: CustomerOption[]
}) {
  return (
    <>
      <Head title={`Edit ${project.display_name}`}>
        <meta name="description" content={`Edit details for ${project.display_name}.`} />
        <meta property="og:title" content={`Edit ${project.display_name}`} />
        <meta property="og:description" content={`Edit details for ${project.display_name}.`} />
      </Head>
      <AppShell>
        <PageHeader
          title={`Edit ${project.display_name}`}
          actions={
            <Button asChild variant="ghost">
              <Link href={`/projects/${project.id}`}>Back to project</Link>
            </Button>
          }
        />
        <div className="mt-8">
          <ProjectForm
            customers={customers}
            action={`/projects/${project.id}`}
            method="patch"
            submitLabel="Save changes"
            showScheduleFields
            initial={{
              lot_number: project.lot_number,
              plan_name: project.plan_name,
              elevation: project.elevation,
              address: project.address,
              notes: project.notes,
              status: project.status,
              customer_id: project.customer_id,
              community_id: project.community_id,
              building_type: project.building_type,
              work_type: project.work_type,
              gate_code: project.gate_code,
              project_manager: project.project_manager,
              customer_phone: project.customer_phone,
              unit_apartment: project.unit_apartment,
              city: project.city,
              state: project.state,
              postal_code: project.postal_code,
              subfloor: project.subfloor,
              schedule_comments: project.schedule_comments,
            }}
          />
        </div>
      </AppShell>
    </>
  )
}
